import React, {useEffect, useRef, useState} from "react";
import { useNavigate, useLocation } from "react-router-dom";
// import {useGetUserQuery, useCreatePaymentMutation, useGetPaymentsQuery} from "../services/endpoints/user.api";
// import logo from "../assets/media/logo_pay.png";
// import { QRCodeCanvas } from 'qrcode.react';  // Importa il componente QRCode
import './Homepage.css';
import Card from './CardComponent';
import CardContent from './CardContent';
import Carousel from './CarouselComponent';
import Header from './base/HeaderComponent'
import Footer from "./base/FooterComponent";
import CardSection from "./CardSections";
import IntroSection from "./IntroSection";
import InfoSection from "./InfoSection";
import HowToSection from "./HowToSection";
import StatsSection from "./StatsSection";
const Homepage = () => {
    const images = [
        { src: '/1.jpg', alt: 'Conversazione umana' },
        { src: '/2.jpg', alt: 'Ascolto empatico' },
        { src: '/3.jpg', alt: 'Supporto riservato' },
    ];
    const { hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const id = hash.replace('#', '');
            const el = document.getElementById(id);
            if (el) {
                // Scroll dolce
                el.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [hash]);
    return (
        <div>
           <Header></Header>
            <Carousel images={images}></Carousel>
            <StatsSection/>
            <IntroSection/>
            <InfoSection/>
            <HowToSection/>
            <CardSection/>
            <Footer></Footer>
        </div>
    );
};

export default Homepage;
// const Homepage = () => {
//     const location = useLocation();
//     const nick = String(location.pathname.split("/").filter(Boolean).pop());
//     const navigate = useNavigate();
//     const [price, setPrice] = useState("");
//     const [description , setDescription] = useState("");
//     const [link , setLink] = useState("");
//     const [btc , setBtc] = useState("");
//     const [isFirstStepOpen, setIsFirstStepOpen] = useState(true);
//     const [isSecondStepOpen, setIsSecondStepOpen] = useState(false);
//     const [isThirdStepOpen, setIsThirdStepOpen] = useState(false);
//     const [isFourthStepOpen, setIsFourthStepOpen] = useState(false);
//     const [createPayment, { isLoading: isCreatePaymentLoading }] = useCreatePaymentMutation()
//     const [paymentId, setPaymentId] = useState(null);
//     const [paymentStatus, setPaymentStatus] = useState(null);
//     const {
//         data: paymentData
//     } = useGetPaymentsQuery({ chargeId: paymentId }, {
//         skip:!paymentId,
//         pollingInterval: paymentId ? 5000 : undefined, // solo se esiste
//     });
//
//     const { data: user, isLoading: userLoading, isFetching: userFetching } =
//         useGetUserQuery({ nickname: nick });
//     const [cont, setCont] = useState(0)
//     const prevStatusRef = useRef();
//
//     useEffect(() => {
//         console.log(paymentId)
//         if (!paymentData) {
//             return
//         }
//
//         const currentStatus = paymentData?.status;
//         const prevStatus = prevStatusRef.current;
//
//         // Solo se cambia lo status, facciamo qualcosa
//         if (currentStatus !== prevStatus) {
//             prevStatusRef.current = currentStatus;
//
//             if (currentStatus === "confirmed") {
//                 setPaymentStatus("confirmed");
//                 setPaymentId(null)
//                 setIsThirdStepOpen(false);
//                 setIsFourthStepOpen(true);
//
//             } else {
//                 console.log('Pagamento non ricevuto')
//             }
//         }
//     }, [paymentData,paymentId]);
//
//     const goToSecondStep = () => {
//        setIsFirstStepOpen(false);
//        setIsSecondStepOpen(true);
//     }
//
//     const goToThirdStep = async () => {
//         if(user) {
//             if (!price || !description) {
//                 alert("Per favore, imposta sia il prezzo che la descrizione.");
//                 return;
//             }
//             const formData = {
//                 name: "Pagamento generato da " + user[0].nickname,
//                 description,
//                 pricing_type: "fixed_price",
//                 local_price: {
//                     amount: String(convertPrice(price)),
//                     currency: "EUR"
//                 },
//                 metadata: {
//                     merchantId: user[0]._id
//                 }
//             }
//             const {data, error} = await createPayment(formData);
//             if (data) {
//                 setLink(data.checkout_url)
//                 setPrice(price)
//                 setBtc(data.btc)
//                 setPaymentId(data.chargeId)
//                 setIsSecondStepOpen(false);
//                 setIsThirdStepOpen(true);
//             }
//             if (error) {
//                 alert("Errore nella creazione del pagamento: " + error)
//             }
//
//         }
//     }
//
//     const convertPrice = (price) => {
//         return price.replace(",", ".")
//     };
//
//     const handleNumpadClick = (num) => {
//         setPrice((prevPrice) => {
//             let cleanPrice = prevPrice.replace(",", ""); // Rimuove la virgola temporaneamente
//             cleanPrice = cleanPrice.replace(/^0+/, ""); // Rimuove eventuali zeri iniziali
//             cleanPrice = cleanPrice + num; // Aggiunge il numero
//
//             if (cleanPrice.length === 1) {
//                 cleanPrice = "0" + cleanPrice; // Mantiene almeno una cifra prima della virgola
//             }
//
//             const euros = cleanPrice.slice(0, -2) || "0"; // Parte intera
//             const cents = cleanPrice.slice(-2); // Parte decimale
//
//             const newPrice = parseFloat(`${euros}.${cents}`);
//             if (newPrice > 450) return prevPrice; // Impedisce di superare 450 euro
//
//             return `${euros},${cents}`; // Ricompone il prezzo nel formato corretto
//         });
//     };
//     const handleDelete = () => {
//         setPrice((prevPrice) => {
//             let cleanPrice = prevPrice.replace(",", ""); // Rimuove la virgola temporaneamente
//             cleanPrice = cleanPrice.slice(0, -1) || "0"; // Rimuove l'ultimo carattere
//
//             if (cleanPrice.length < 3) {
//                 cleanPrice = "0" + cleanPrice; // Mantiene almeno un numero prima della virgola
//             }
//
//             const euros = cleanPrice.slice(0, -2) || "0";
//             const cents = cleanPrice.slice(-2).padStart(2, "0"); // Mantiene sempre due cifre decimali
//
//             return `${euros},${cents}`;
//         });
//     };
//
//     const handleDescriptionChange = (event) => {
//         setDescription(event.target.value);
//     };
//
//
//     return (
//         <div
//             className="d-flex justify-content-center align-items-center vh-100"
//             style={{ backgroundColor: "#040429" }}
//         >
//             {userLoading || userFetching ? (
//                 <div>Loading...</div>
//             ) : user?.length === 0 ? (
//                 <div
//                     className="card p-4 shadow-lg align-items-center"
//                     style={{ width: "400px", borderRadius: "15px" }}
//                 >
//                     <div className="card-body text-center" style={{alignContent: "center"}}>
//                         <img
//                             src={logo}
//                             alt="Logo"
//                             className="img-fluid mb-3"
//                             style={{ maxWidth: "250px" }}
//                         />
//                         <h2 className="card-title">Nessun utente autorizzato!</h2>
//                     </div>
//                 </div>
//             ) : isFirstStepOpen ? (
//                 <div
//                     className="card p-4 shadow-lg align-items-center"
//                     style={{ width: "600px", height:"600px", borderRadius: "15px"}}
//                 >
//                     <img
//                         src={logo}
//                         alt="Logo"
//                         className="img-fluid mb-3"
//                         style={{ maxWidth: "250px" }}
//                     />
//                     <div className="card-body text-center" style={{alignContent : "center"}}>
//
//                         <h2 className="card-title mt-2">
//                             Benvenuto, {user[0]?.name} {user[0]?.surname}!
//                         </h2>
//                         <p className="card-text mt-3">
//                             Crea il pagamento per il tuo cliente!
//                         </p>
//                         <button className="btn btn-success mt-3" onClick={() => goToSecondStep()}>Inizia</button>
//                     </div>
//                 </div>
//             ) : isSecondStepOpen ? (
//                 <div className="card p-4 shadow-lg" style={{ width: "400px", borderRadius: "15px" }}>
//                     <div className="card-body text-center">
//                         <img src={logo} alt="Logo" className="img-fluid mb-3" style={{ maxWidth: "250px" }} />
//                         {/*<h4 className="card-title mb-4">Imposta prezzo e descrizione</h4>*/}
//                         <div className="price-display price mt-2">€ {price || "0,00"}</div>
//                         <div className="price-display">(min 3,00  - max 450,00€)</div>
//                         <div className="numpad d-grid gap-2 mt-3" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "10px" }}>
//                             {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
//                                 <button key={num} className="btn btn-light tastierinoButton" onClick={() => handleNumpadClick(num.toString())}>
//                                     {num}
//                                 </button>
//                             ))}
//                             <button className="btn btn-light tastierinoButton" onClick={() => handleNumpadClick("0")}>0</button>
//                             <button className="btn btn-danger" onClick={handleDelete}>C</button>
//                         </div>
//                         <div className="form-floating mt-3">
//                             <textarea className="form-control" placeholder="Inserisci descrizione" id="desc" style={{ height: "100px" }} aria-label="Descrizione" value={description} onChange={handleDescriptionChange}></textarea>
//                             <label htmlFor="desc">Descrizione</label>
//                         </div>
//                         <button className="btn btn-success mt-3" onClick={() => goToThirdStep()}>
//                             {isCreatePaymentLoading ? <span className="spinner-border spinner-border-sm"></span> : "Genera pagamento"}
//                         </button>
//                     </div>
//                 </div>
//             ): isThirdStepOpen ? (
//                 <div
//                 className="card p-4 shadow-lg"
//                 style={{ width: "400px", borderRadius: "15px" }}
//                 >
//                 <div className="card-body text-center">
//                 <img
//                 src={logo}
//                 alt="Logo"
//                 className="img-fluid mb-3"
//                 style={{ maxWidth: "250px" }}
//                 />
//                 <h4 className="card-title">
//                     {btc} BTC
//                 </h4>
//                     <span>
//                         {price} €
//                     </span>
//                     <h5 className="card-title mt-4">
//                     Descrizione acquisto
//                     </h5>
//                         <span>{description}</span>
//                 <p className="card-text mt-5">
//                     <h5 className="card-title mb-3">Scansiona il QR Code per il pagamento</h5>
//                     {/* Genera il QR code dal link */}
//                     <QRCodeCanvas value={link} size={256} level="H" />
//                 </p>
//                     {paymentStatus !== "confirmed" && (
//                         <h4 className="mt-3 text-danger">In attesa del pagamento...</h4>
//                     )}
//                 </div>
//                 </div>
//                 ): isFourthStepOpen ? (
//                 <div
//                     className="card p-4 shadow-lg"
//                     style={{ width: "400px", borderRadius: "15px" }}
//                 >
//                     <div className="card-body text-center">
//                         <img
//                             src={logo}
//                             alt="Logo"
//                             className="img-fluid mb-3"
//                             style={{ maxWidth: "250px" }}
//                         />
//                         <h4 className="card-title">
//                             {btc} BTC
//                         </h4>
//                         <span>
//                         {price} €
//                     </span>
//                         <h5 className="card-title mt-4">
//                             Descrizione acquisto
//                         </h5>
//                         <span>{description}</span>
//                         <p className="card-text mt-5">
//                             <h4 className="text-success">Pagamento ricevuto!</h4>
//                             {/* Genera il QR code dal link */}
//                             {/*<QRCodeCanvas value={link} size={256} level="H" />*/}
//                         </p>
//                     </div>
//                 </div>)
//                 : null}
//         </div>
//     );
// };
//
// export default Homepage;
